export default __webpack_public_path__ + "assets/avatar.1e3565ea.png";